import { InPersonLocation, ModalityType } from '../../models/calendar/CalendarV2'

/**
 * Constants currently used for /availability API for calendar service
 */
export const SLICE_DURATION_MINUTES = 30
export const SLICE_DURATION_USER_MINUTES = 60
export const DAILY_START_TIME = '07:00:00'
export const DAILY_END_TIME = '22:00:00'
export const FOURTEEN_DAYS_TO_MS = 1.21e9
export const SIXTY_DAYS_TO_MS = 5.184e9
export const THIRTY_DAYS_TO_MS = 2.592e9
export const TWENTY_EIGHT_DAYS_TO_MS = 2.4192e9

export enum PHONE_TYPES {
  MOBILE = 'mobile',
  LANDLINE = 'landline',
}

export type CalendarAppointment = {
  time: string
  date: string
  timeZone: string
}

export type CalendarAppointmentWithModality = {
  date: string
  time: string
  duration?: number
  modalityType?: ModalityType
  appointmentLocation?: InPersonLocation
}

export enum BOOKING_CHANNEL_TYPE {
  CLIENT_REBOOKING = 'client_rebooking',
  DIRECT_BOOKING_LINK = 'direct_booking_link',
  DIRECT_PATH = 'direct_program_link',
  TRIAGE = 'triage',
  CNT_BOOKING = 'cnt_booking',
  FAVORITED_PROVIDERS = 'favorited_providers_booking',
  SAVED_REENGAGEMENT_EMAILS_DIRECT_BOOKING = 'saved_reengagement_emails_direct_booking',
  SAVED_REENGAGEMENT_EMAILS_REPLAY_SEARCH = 'saved_reengagement_emails_replay_search',
  PP_API_AUTO_APPT_CREATION = 'pp_api_auto_appt_creation',
  ACCOUNT_MIGRATION = 'account_migration',
}
